import { getFacetAttributeName } from "@/components/Search/utils/getFacetAttributeName";

/**
 * Transform search URLs to use correct facet parameter names based on the active Algolia index.
 * This ensures navigation links with hardcoded facet names (like "subject", "learning_type")
 * get translated to the correct names for the active index (e.g., "attributes", "productType").
 */
export function transformSearchUrl(url: string, indexName: string): string {
  if (!url || !url.includes("/search?")) return url;

  const [path, queryString] = url.split("?");
  if (!queryString) return url;

  const params = new URLSearchParams(queryString);
  const newParams = new URLSearchParams();

  const FACET_PARAMS = [
    "subject",
    "learning_type",
    "skills.skill",
    "ai_languages.transcription_languages",
    "ai_languages.translation_languages",
  ];

  params.forEach((value, key) => {
    if (FACET_PARAMS.includes(key)) {
      const newKey = getFacetAttributeName(key as any, { indexName });
      newParams.append(newKey, value);
    } else {
      newParams.append(key, value);
    }
  });

  return `${path}?${newParams.toString()}`;
}
